import clinohealthLogo from "../assets/images/clinohealthinovation_logo.jpg";
import rechargekitLogo from "../assets/images/rechargekit.webp";
import javaTechnocratLogo from "../assets/images/Jt.png";
import neoSOFT from "../assets/images/neosoft-logo.svg";
import lit from "../assets/images/lit.png";
import ea from "../assets/images/EA.png";
import smylee from "../assets/images/Smylee.png";
import coverSure from "../assets/images/CoverSure.png";

export const coreSkills = [
  // Row 1: Core Technologies (Largest)
  [
    { name: "React Native", img: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K" },
    { name: "Next JS", img: "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/nextjs-icon.png" },
    { name: "Node JS", img: "https://cdn-icons-png.flaticon.com/512/5968/5968322.png" },
    { name: "Express JS", img: "https://ajeetchaulagain.com/static/7cb4af597964b0911fe71cb2f8148d64/87351/express-js.png" },
    { name: "Flutter", img: "https://cdn.iconscout.com/icon/free/png-256/free-flutter-logo-icon-download-in-svg-png-gif-file-formats--programming-language-coding-development-logos-icons-1720090.png?f=webp" },
    { name: "FastAPI", img: "https://avatars.githubusercontent.com/u/156354296?s=200&v=4" },
  ],
  // Row 2: Databases & Services
  [
    { name: "Firebase", img: "https://static.invertase.io/assets/social/firebase-logo.png" },
    { name: "Supabase", img: "https://static.cdnlogo.com/logos/s/58/supabase_800.png" },
    { name: "MySQL", img: "https://cdn-icons-png.flaticon.com/128/15484/15484291.png" },
    { name: "PostgreSQL", img: "https://novastor.com/hs-fs/hubfs/Postgre%20SQL.png?width=900&height=666&name=Postgre%20SQL.png" },
    { name: "MongoDB", img: "https://d2lgmzy8vjj79z.cloudfront.net/mongodb.svg" },
  ],
  // Row 3: Cloud, OS & Native
  [
    { name: "AWS", img: "https://cdn.iconscout.com/icon/free/png-256/free-aws-logo-icon-download-in-svg-png-gif-file-formats--cloud-computing-network-server-database-brand-pack-logos-icons-1583149.png?f=webp&w=256" },
    { name: "Azure", img: "https://www.c-sharpcorner.com/UploadFile/BlogImages/01232023170209PM/Azure%20Icon.png" },
    { name: "Google Cloud", img: "https://www.gstatic.com/bricks/image/rc7m6af1wpQO_v5GlttqQ_nbbC4jLY0EEN4aVof8WsJLmVyWrtPTHYb5XSm4sJY_142oDc1IsIs.png" },
    { name: "Android", img: "https://cdn-icons-png.flaticon.com/128/270/270780.png" },
    { name: "iOS", img: "https://cdn3.iconfinder.com/data/icons/social-media-logos-i-filled-line/2048/5315_-_Apple-512.png" },
  ],
  // Row 4: Tools & Helping Tech (Smallest)
  [
    { name: "Git", img: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png" },
    { name: "Linux", img: "https://cdn-icons-png.flaticon.com/128/518/518713.png" },
    { name: "Postman", img: "https://cdn.iconscout.com/icon/free/png-256/free-postman-logo-icon-download-in-svg-png-gif-file-formats--technology-social-media-company-vol-5-pack-logos-icons-3030217.png?f=webp&w=256" },
    { name: "Cursor", img: "https://cursor.com/marketing-static/_next/image?url=%2Fmarketing-static%2Fdownload%2Fapp-icon-2d-light.png&w=3840&q=70&dpl=dpl_8cKUYZu1sqYpRaRk2LDZDeUbWZxF" },
    { name: "App Store", img: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/App_Store_%28iOS%29.svg/512px-App_Store_%28iOS%29.svg.png" },
    { name: "Play Store", img: "https://developer.android.com/static/distribute/console/images/play-console-blue.png" },
  ]
];

export const Bio = {
  name: "Amaresh Pati",
  roles: [
    "Full Stack Developer",
    "Mobile App Developer",
    "Devops Engineer",
  ],
  description:
    "I am a skilled and adaptive developer, driven by a passion for tech innovation. With hands-on experience in delivering scalable, high-quality solutions, I approach challenges with a growth mindset and a commitment to impactful results.",
  experienceYears: new Date().getFullYear() - 2022,
  github: "https://github.com/amareshpati",
  resume: "/resume.pdf",
  linkedin: "https://www.linkedin.com/in/amareshpati",
  twitter: "https://x.com/amaresh_1301",
  insta: "https://www.instagram.com/amaresh_13/",
  blogs: "https://blogs.devvloper.in",
  email: "patiamaresh13@gmail.com",
  brandTagline: "Building scalable mobile & web solutions that users love.",
  impactStats: [
    { label: "Products Developed", value: "10+" },
    { label: "Active Users", value: "150k+" },
    { label: "Uptime Managed", value: "99.9%" }
  ]
};

export const skills = [
  {
    title: "Application Development",
    skills: [
      { name: "React Native", image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K" },
      { name: "Flutter", image: "https://cdn.iconscout.com/icon/free/png-256/free-flutter-logo-icon-download-in-svg-png-gif-file-formats--programming-language-coding-development-logos-icons-1720090.png?f=webp" },
      { name: "Android", image: "https://cdn-icons-png.flaticon.com/128/270/270780.png" },
      { name: "iOS", image: "https://cdn3.iconfinder.com/data/icons/social-media-logos-i-filled-line/2048/5315_-_Apple-512.png" },
    ],
  },
  {
    title: "Backend & Database",
    skills: [
      { name: "Node Js", image: "https://cdn-icons-png.flaticon.com/512/5968/5968322.png" },
      { name: "Express Js", image: "https://ajeetchaulagain.com/static/7cb4af597964b0911fe71cb2f8148d64/87351/express-js.png" },
      { name: "MySQL", image: "https://cdn-icons-png.flaticon.com/128/15484/15484291.png" },
      { name: "MongoDB", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2ZYtHv2OLXmthRPbkmENZRXuqBVDwlsrZ1A&s" },
      { name: "Firebase", image: "https://firebase.google.com/static/images/brand-guidelines/logo-logomark.png" },
    ],
  },
  {
    title: "DevOps & Cloud",
    skills: [
      { name: "AWS", image: "https://cdn.iconscout.com/icon/free/png-256/free-aws-logo-icon-download-in-svg-png-gif-file-formats--cloud-computing-network-server-database-brand-pack-logos-icons-1583149.png?f=webp&w=256" },
      { name: "Azure", image: "https://www.c-sharpcorner.com/UploadFile/BlogImages/01232023170209PM/Azure%20Icon.png" },
      { name: "Git", image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png" },
      { name: "Google Cloud", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgFIqWrmOpFaeaJ8plSE6-zr2fxa8OjXL6kg&s" },
      // { name: "Google Play Console", image: "https://play-lh.googleusercontent.com/4_RW0mQ5mJhGGJVydTlQsQ0pnqAYq9UoTVm2_gElrgRM13Q02w43HPgYVaMFy4b4smmF" },
      { name: "Apple App Store", image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/App_Store_%28iOS%29.svg/512px-App_Store_%28iOS%29.svg.png" },
    ],
  },
  {
    title: "Web Development",
    skills: [
      { name: "React Js", image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K" },
      // { name: "Redux", image: "https://img.icons8.com/color/512/redux.png" },
      { name: "Next Js", image: "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/nextjs-icon.png" },
      // { name: "HTML", image: "https://cdn-icons-png.flaticon.com/128/1051/1051277.png" },
      // { name: "CSS", image: "https://cdn-icons-png.flaticon.com/128/732/732190.png" },
      // { name: "JavaScript", image: "https://cdn-icons-png.flaticon.com/128/5968/5968292.png" },
      // { name: "Bootstrap", image: "https://cdn-icons-png.flaticon.com/128/5968/5968672.png" },
      { name: "Material UI", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQe5jAcRSDN_ck1Cnivp0JIcRPdJ7-BmkvuAA&s" },
      { name: "Tailwind CSS", image: "https://cdn3d.iconscout.com/3d/free/thumb/free-tailwind-3d-icon-download-in-png-blend-fbx-gltf-file-formats--html-logo-css-framework-customizable-coding-lang-pack-logos-icons-7577995.png" },
    ],
  },
  {
    title: "Operating Systems",
    skills: [
      { name: "Linux", image: "https://cdn-icons-png.flaticon.com/128/518/518713.png" },
      { name: "Windows", image: "https://cdn-icons-png.flaticon.com/128/270/270831.png" },
      { name: "MacOS", image: "https://i.pinimg.com/474x/77/f0/33/77f033d90e28c29dc6ce7006e66d0caa.jpg" },
    ],
  },
  {
    title: "Tools & Others",
    skills: [
      { name: "VS Code", image: "https://cdn-icons-png.flaticon.com/128/906/906324.png" },
      { name: "Postman", image: "https://cdn.iconscout.com/icon/free/png-256/free-postman-logo-icon-download-in-svg-png-gif-file-formats--technology-social-media-company-vol-5-pack-logos-icons-3030217.png?f=webp&w=256" },
      { name: "X Code", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPE69SFNIWcmqMOVlPvSolhPhLHYVbJkuSiA&s" },
      { name: "Android Studio", image: "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/android-studio-icon.png" },
    ],
  },
];



export const experiences = [{
  id: 3,
  img: neoSOFT, // NeoSOFT logo
  role: "Software Engineer",
  company: "NeoSOFT Pvt. Ltd.",
  date: "Dec 2024 – Present",
  desc: [
    "Sportz Interactive – European Athletics App: Built core RN features for real-time live event coverage with zero noticeable UI lag; handled 5,000+ concurrent users.",
    "Coversure – Motor Insurance: Improved purchase workflow for an app with 150,000+ downloads (4.5★), reduced crashes, and clarified critical UI flows.",
    "Smylee App: Upgraded to React Native 0.81.2 (New Architecture) across iOS & Android, boosting stability and performance for 8,000+ users."
  ],
  skills: [
    "React Native",
    "TypeScript",
    "Redux",
    "Reanimated",
    "iOS",
    "Android"
  ],
  doc: "",
},
{
  id: 3,
  img: clinohealthLogo, // Clinohealth Innovation logo URL
  role: "Full-Stack Developer",
  company: "Clinohealth Innovation Pvt. Ltd.",
  date: "Sep 2023 – Dec 2024",
  desc: [
    "Created a suite of 4+ mobile apps and 2 web applications, enhancing performance and user satisfaction by 30%.",
    "Developed an Ambulance Booking App, reducing response time by 20%, improving emergency service response.",
    "Built a Doctor Booking App to streamline scheduling, increasing accessibility for users.",
    "Developed an IoT Monitoring App to optimize data tracking, reducing diagnostic errors by 35%.",
    "Managed AWS infrastructure for 100,000+ users, achieving 99.9% uptime, scalability, and security.",
    "Led backend development using Express.js, MySQL, REST APIs, and MongoDB, boosting database performance by 25%.",
    "Deployed 15+ apps on AWS, Google Play Console, and Apple App Store, enhancing deployment efficiency by 40%.",
    "Led a team of 10 developers, improving team productivity and code quality through peer code reviews and pair programming."
  ],
  skills: [
    "React Native",
    "Flutter",
    "Node.js",
    "Express.js",
    "MySQL",
    "AWS",
    "MongoDB",
    "Leadership"
  ],
  doc: "", // Add documentation URL if available
},
{
  id: 1,
  img: rechargekitLogo, // RechargeKit logo URL
  role: "Mobile Application Developer",
  company: "RechargeKit Communication Pvt. Ltd.",
  date: "May 2022 – Aug 2023",
  desc: [
    "Built 8 mobile apps using React Native and Flutter, achieving over 90% ratings on Google Play and App Store.",
    "Developed a Doctor Booking App, increasing booking efficiency by 25% and boosting user retention.",
    "Enhanced e-commerce and inventory management processes, reducing drop-off rates by 18% and improving operational efficiency by 30%.",
    "Implemented audio and video uploading capabilities for media handling, supporting diverse multimedia formats.",
    "Improved UI/UX for cross-device responsiveness, enhancing user engagement.",
    "Integrated Firebase for push notifications and analytics, improving user retention by 10%.",
    "Optimized API performance with GraphQL and Axios, reducing load times by 30%."
  ],
  skills: [
    "React Native",
    "Flutter",
    "Firebase",
    "Git",
    "JavaScript",
    "GraphQL",
    "iOS",
    "Android"
  ],
  doc: "", // Add documentation URL if available
},
{
  id: 0,
  img: javaTechnocratLogo, // Java Technocrat logo URL
  role: "Technical Trainer",
  company: "Java Technocrat",
  date: "Sep 2021 – May 2022",
  desc: [
    "Conducted 50+ training sessions for 500+ students on Java, Python, and Oracle Database, focusing on practical skills and industry standards.",
    "Delivered 20+ webinars and seminars to simplify complex technical concepts for large audiences."
  ],
  skills: [
    "Java",
    "Python",
    "Oracle Database",
    "Teaching",
    "JavaScript"
  ],
  doc: "", // Add documentation URL if available
},
];


export const education = [
  {
    id: 0,
    img: lit, // Replace with your image URL
    school: "Lakshya Institute of Technology, Bhubaneswar, Odisha",
    date: "Aug 2018 - Sep 2021",
    grade: "N/A",
    desc: "I completed my Bachelor of Science in Computer Science from Lakshya Institute of Technology, Bhubaneswar. During my studies, I gained foundational knowledge in programming, algorithms, data structures, and other essential areas of computer science.",
    degree: "Bachelor of Science in Computer Science",
  }
];

export const projects = [
  {
    id: 15,
    title: "European Athletics – Official App",
    description: [
      "Official app for European Athletics with real-time results, live coverage, schedules, athlete profiles, and personalized notifications.",
      "Community engagement via polls and quizzes during events.",
      "Recent refresh for 2025 season championships (Madrid/Maribor) with exclusive content and updates.",
      "Delivered core RN features and performance optimizations for smooth live event experiences."
    ],
    image: ea,
    imageType: "round",
    tags: ["React Native", "Live Results", "Sports", "Push Notifications"],
    category: "Mobile app",
    github: "",
    webapp: "",
    playStore: "https://play.google.com/store/apps/details?id=com.europeanathletics.mobile&pcampaignid=web_share",
    appStore: "https://apps.apple.com/in/app/european-athletics/id6477942665",
    overview: "Official European Athletics app delivering live results, schedules, and athlete insights with interactive fan features.",
    pinned: true,
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 17,
    title: "CoverSure – Insurance Made Easy",
    description: [
      "Personalized insurance portfolio manager for health, life, and motor policies with renewals, gap detection, and emergency assistance.",
      "Implemented RN performance improvements, critical purchase/renewal UX flows, and crash-rate reductions.",
      "Integrated reminders, document handling, and account-level protections across platforms."
    ],
    image: coverSure,
    imageType: "round",
    tags: ["React Native", "Insurance", "Notifications", "iOS", "Android"],
    category: "Mobile app",
    github: "",
    webapp: "",
    playStore: "https://play.google.com/store/apps/details?id=com.coversure&pcampaignid=web_share",
    appStore: "https://apps.apple.com/in/app/coversure-insurance-made-easy/id6454847100",
    overview: "All-in-one insurance app: manage policies, get renewal alerts, access assistance, and understand coverage.",
    pinned: true,
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 25,
    title: "Create RN Quickstart",
    description: [
      "CLI tool for instantly scaffolding React Native projects with best practices.",
      "Simplifies the complex setup process of RN applications.",
      "Provides a clean, modular architecture out of the box.",
      "Enables developers to jump-start their mobile development workflow."
    ],
    image: "https://img.freepik.com/free-vector/hand-drawn-web-developers_23-2148819604.jpg?semt=ais_hybrid",
    imageType: "rectangular",
    tags: ["Node.js", "CLI Tool", "React Native", "Automation"],
    category: "Web app",
    github: "https://github.com/amareshpati/create-rn-quickstart",
    webapp: "",
    overview: "Command-line utility to bootstrap React Native projects quickly and efficiently.",
    pinned: true,
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 20,
    title: "AI Mail Bot",
    description: [
      "A smart tool to generate and auto-send personalized emails to recruiters using AI.",
      "Powered by Google Gemini API for intelligent email generation tailored per recipient.",
      "Upload a CSV with recruiter details and your resume — the bot drafts, queues, and sends emails automatically.",
      "Web interface lets you review, edit, and approve emails before dispatching.",
      "Built with TypeScript and HTML; supports daily sending limits and scheduling."
    ],
    image: "https://img.freepik.com/free-vector/hand-drawn-web-developers_23-2148819604.jpg?semt=ais_hybrid",
    imageType: "rectangular",
    tags: ["TypeScript", "Node.js", "Gemini AI", "Automation", "Email"],
    category: "Backend",
    github: "https://github.com/amareshpati/ai-mail-bot",
    webapp: "",
    playStore: "",
    appStore: "",
    overview: "AI-powered email bot that generates and auto-sends personalized recruiter outreach emails using Gemini API.",
    pinned: true,
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 24,
    title: "RN Boilerplate App",
    description: [
      "Professional-grade React Native boilerplate with a robust file structure.",
      "Pre-configured with Redux, Navigation, and essential utility hooks.",
      "Includes reusable UI components and standard styling patterns.",
      "Designed to significantly reduce initial project setup time."
    ],
    image: "https://img.freepik.com/free-vector/app-development-banner_33099-1720.jpg",
    imageType: "rectangular",
    tags: ["React Native", "Boilerplate", "Redux", "Best Practices"],
    category: "Mobile app",
    github: "https://github.com/amareshpati/rn-boilerplate-app",
    webapp: "",
    overview: "A production-ready React Native starter template for rapid development.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 16,
    title: "Smylee – Plan Everyday Events",
    description: [
      "Event-planning app to organize meetups with group/personal chat, RSVP tracking, reminders, and charity-pledge commitment features.",
      "Built and upgraded RN flows; stabilized new architecture and notifications pipeline across iOS/Android.",
      "Focused on snappy list rendering and safe background tasks for reminders and updates."
    ],
    image: smylee,
    imageType: "round",
    tags: ["React Native", "Events", "Push Notifications", "iOS", "Android"],
    category: "Mobile app",
    github: "",
    webapp: "https://play.google.com/store/apps/details?id=com.smylee.smyleeapp",
    overview: "Plan parties and meetups with chat, RSVPs, reminders, and a unique charity-pledge mechanism.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 12,
    title: "IoT Device Connection App",
    description: [
      "Industrial IoT application developed at Clino Health for device monitoring.",
      "Used Express.js and MQTT protocol over AWS for real-time communication.",
      "Implemented WebSocket for low-latency sensor data fetching.",
      "Successfully delivered multiple sub-projects within the IoT ecosystem."
    ],
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLtMS8qiUFvwKVi8C4JrdWm9dOwiZvnwynzA&s",
    imageType: "rectangular",
    tags: ["Express.js", "MQTT", "AWS", "IoT", "WebSocket"],
    category: "Backend",
    github: "",
    webapp: "",
    overview: "Real-time IoT sensor monitoring system with MQTT and AWS.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 18,
    title: "Mo Ambulance – Emergency Booking",
    description: [
      "Ambulance booking app for quick emergency medical response.",
      "Developed for Clinohealth Innovation, reducing emergency response times by 20%.",
      "Real-time tracking and booking features for seamless ambulance dispatch."
    ],
    image: "https://img.freepik.com/free-vector/app-development-banner_33099-1720.jpg",
    imageType: "rectangular",
    tags: ["React Native", "Emergency", "Healthcare", "Android"],
    category: "Mobile app",
    github: "",
    webapp: "",
    playStore: "https://play.google.com/store/apps/details?id=com.moambulance&pcampaignid=web_share",
    appStore: "",
    overview: "Emergency ambulance booking app with real-time tracking for faster medical response.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 23,
    title: "Mo Ambulance Website",
    description: [
      "Official informative and booking website for Mo Ambulance services.",
      "Designed for quick access to emergency contact and booking info.",
      "Responsive layout for ease of use on all device types during emergencies."
    ],
    image: "https://img.freepik.com/free-vector/hand-drawn-web-developers_23-2148819604.jpg?semt=ais_hybrid",
    imageType: "rectangular",
    tags: ["Web Development", "Healthcare", "Emergency"],
    category: "Web app",
    github: "",
    webapp: "https://moambulance.in",
    overview: "Official website for Mo Ambulance emergency services.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 13,
    title: "IoT Sensor Data Website",
    description: [
      "Web-based dashboard for optimized showcasing of real-time sensor data.",
      "Responsible for developing efficient algorithms to process and visualize data.",
      "Integrated live camera feeds and sensor values for comprehensive monitoring.",
      "Deployed on AWS with a focus on high-performance data visualization."
    ],
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLtMS8qiUFvwKVi8C4JrdWm9dOwiZvnwynzA&s",
    imageType: "rectangular",
    tags: ["IoT", "Next.js", "AWS", "Data Visualization", "Live Camera"],
    category: "Web app",
    github: "",
    webapp: "",
    overview: "High-performance IoT dashboard for real-time sensor data and logic.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 10,
    title: "Event Booking App",
    description: [
      "Freelance project for booking and managing events seamlessly.",
      "Developed both mobile application and scalable backend.",
      "Hosted on AWS for reliable performance and high availability.",
      "Features include event browsing, booking, and real-time updates."
    ],
    image: "https://img.freepik.com/free-vector/hand-drawn-web-developers_23-2148819604.jpg?semt=ais_hybrid",
    imageType: "rectangular",
    tags: ["React Native", "Express.js", "AWS", "SQL Server"],
    category: ["Mobile app", "Web app", "Backend"],
    github: "",
    webapp: "",
    overview: "Complete event booking solution with AWS-hosted backend.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 8,
    title: "Refab Emi Locker",
    description: [
      "An app designed for smartphone sellers offering self-financing options.",
      "Allows sellers to control sold devices, including locking and stopping network access, when EMIs are unpaid.",
      "Conducted extensive R&D to ensure smooth functionality and robust security.",
      "Integrated Google Zero Touch Portal and Work Profile for seamless device management.",
      "Managed a team to ensure timely delivery and coordination across platforms."
    ],
    image: "https://acropolium.com/img/articles/find-backend-developers/img01.jpg",
    imageType: "rectangular",
    tags: ["React Native", "Native Android", "Google Zero Touch", "Security"],
    category: "Mobile app",
    github: "",
    webapp: "",
    playStore: "https://play.google.com/store/apps/details?id=com.apptimate.rf",
    appStore: "",
    overview: "Remote device management and locking system for financed smartphones.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 21,
    title: "Refab SalesForce App",
    description: [
      "Enterprise sales force automation tool for managing purchase orders and inventory.",
      "Streamlines field sales operations with real-time data sync and reporting.",
      "Supports multi-level user access and role-based permissions."
    ],
    image: "https://img.freepik.com/free-vector/app-development-banner_33099-1720.jpg",
    imageType: "rectangular",
    tags: ["React Native", "SalesForce", "Enterprise", "iOS", "Android"],
    category: "Mobile app",
    github: "",
    webapp: "",
    playStore: "https://play.google.com/store/apps/details?id=com.refab_po",
    appStore: "https://apps.apple.com/in/app/refab-salesforces/id1663787287",
    overview: "Sales force management app for tracking orders and sales activities.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 19,
    title: "Ask Hitech – Expert Q&A",
    description: [
      "Expert consultation and Q&A platform connecting users with tech professionals.",
      "Built for iOS with a clean, intuitive interface for asking and answering queries.",
      "Enables knowledge sharing between professionals and users in real time."
    ],
    image: "https://img.freepik.com/free-vector/app-development-banner_33099-1720.jpg",
    imageType: "rectangular",
    tags: ["React Native", "iOS", "Q&A", "Consultation"],
    category: "Mobile app",
    github: "",
    webapp: "",
    playStore: "",
    appStore: "https://apps.apple.com/in/app/ask-hitech/id1660576445",
    overview: "iOS app for expert consultations and tech Q&A, connecting professionals with users in real time.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 22,
    title: "Refab Recharge App",
    description: [
      "Mobile recharge and utility bill payment application.",
      "Integrated secure payment gateways for seamless transactions.",
      "Provides real-time recharge status and transaction history."
    ],
    image: "https://img.freepik.com/free-vector/app-development-banner_33099-1720.jpg",
    imageType: "rectangular",
    tags: ["React Native", "Fintech", "Recharge", "Android"],
    category: "Mobile app",
    github: "",
    webapp: "",
    playStore: "https://play.google.com/store/apps/details?id=com.therefab",
    appStore: "",
    overview: "Fast and secure mobile recharge and bill payment platform.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
  {
    id: 14,
    title: "Personal Portfolio Website",
    description: [
      "Modern, responsive portfolio website built using Next.js and Tailwind CSS.",
      "Features iterative design improvements and performance optimizations.",
      "Showcases projects, experiences, and technical skills with smooth animations.",
      "Optimized for SEO and cross-device compatibility."
    ],
    image: "https://media.istockphoto.com/id/1371339413/photo/co-working-team-meeting-concept-businessman-using-smart-phone-and-digital-tablet-and-laptop.jpg?s=612x612&w=0&k=20&c=ysEsVw3q2axYt3oVZAuQjtHRlN3lY-U_e0ikK5yKIXQ=",
    imageType: "rectangular",
    tags: ["Next.js", "Tailwind CSS", "Portfolio", "Web Development"],
    category: "Web app",
    github: "https://github.com/amareshpati/portfolio-web",
    webapp: "https://devvloper.in",
    overview: "My personal professional portfolio built with Next.js.",
    member: [{ name: "", img: "", linkedin: "", github: "" }]
  },
];

export const testimonials = [
  {
    id: 0, name: 'Avinash Mishra',
    role: 'Project Manager',
    img: 'https://cdn-icons-png.flaticon.com/512/149/149071.png',
    desc: 'Amaresh brings clarity and execution excellence to every project. His technical decisions consistently improved our delivery speed and product stability.',
  },
  {
    id: 1,
    name: 'Yash Shinde',
    role: 'Java Backend Developer',
    img: 'https://cdn-icons-png.flaticon.com/512/149/149071.png',
    desc: 'Amaresh is highly reliable and consistently delivers clean, maintainable code. His attention to performance optimization stands out in every project.',
  },
  {
    id: 2,
    name: 'Aditya Kumar',
    role: 'Product Manager',
    img: 'https://cdn-icons-png.flaticon.com/512/149/149071.png',
    desc: 'Working with Amaresh improved our engineering workflow significantly. He bridges the gap between product vision and technical execution effortlessly.',
  },
];
